// Public ingestion key; override per environment when using separate projects.
export const SENTRY_DSN = "https://0bda058d3aafd92cb56a9c6982d447ac@o4512123748614144.ingest.de.sentry.io/4512123790950480";

/** Keep diagnostic stacks, but discard request content and SDK-collected context. */
export function scrubSentryEvent<T extends { request?: unknown; user?: unknown; breadcrumbs?: unknown; extra?: unknown; contexts?: unknown; spans?: unknown; message?: string; exception?: { values?: Array<{ value?: string }> } }>(event: T): T {
  delete event.request;
  delete event.user;
  delete event.breadcrumbs;
  delete event.extra;
  // Trace identifiers are needed for valid transactions; discard all other context.
  const trace = (event.contexts as { trace?: Record<string, unknown> } | undefined)?.trace;
  delete event.contexts;
  if (trace) event.contexts = { trace: Object.fromEntries(
    ["trace_id", "span_id", "parent_span_id", "op", "status", "origin"].filter(key => typeof trace[key] === "string").map(key => [key, trace[key]])
  ) };
  delete event.spans;
  const redact = (value: string) => value
    .replace(/Bearer\s+[^\s"']+/gi, "Bearer [redacted]")
    .replace(/(?:sk|pk)_(?:live|test)_[a-zA-Z0-9]+/g, "[redacted]")
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, "[email]")
    .replace(/(https?:\/\/[^\s?#]+)[?#][^\s]*/g, "$1")
    .replace(/((?:token|password|secret|api_key)\s*[=:]\s*)[^\s,;]+/gi, "$1[redacted]");
  if (event.message) event.message = redact(event.message);
  for (const value of event.exception?.values || []) {
    if (value.value) value.value = redact(value.value);
  }
  return event;
}
